import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=65eca700&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"
import style0 from "./recommend.vue?vue&type=style&index=0&id=65eca700&prod&lang=scss&scoped=true"
import style1 from "./recommend.vue?vue&type=style&index=1&id=65eca700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eca700",
  null
  
)

export default component.exports